<template>
    <vOrderListComponent v-if="flag" :postList="postList"></vOrderListComponent>
</template>
<script>
import vOrderListComponent from '../../listComponent/order/orderListComponent.vue';
export default {
    name: 'orderList',
    components: {
        vOrderListComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                supplier_rid:true,
                demander_rid:true,
                partner_rid: true,
                addBtn: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            }
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>